<script lang="ts">
  // components
  import ResultsTable from './ResultsTable.svelte';

  // types
  import type { Readable } from 'svelte/store';
  import type { RaceInterface } from '../interfaces';

  /** @type {import('../types.d').ReadableRace} */
  export let feed;

  /** @type {boolean} */
  export let face;

  /** @type {import('../types.d').Crosswalk} */
  export let crosswalk;

    /** @type {import('../types.d').ReadableRace} */
    export let national;

  $: race = feed;
    
</script>

<ResultsTable
  {face}
  {crosswalk}
  nationalCandidates={national ? $national.candidates : ''}
  raceId={$race.id}
  candidates={$race.candidates}
  totalVotes={$race.total_votes}
  totalNationalVotes={national ? $national.total_votes :''}
  office={$race.office}
  precinctsReportingPercent={$race.precincts_reporting_percent}
  eevp={$race.eevp} 
  numOfwinners={$race.number_of_winners}/>